import { Box, Container, Grid, Typography } from "@mui/material";
import CardParceiro from "../../painel/contador/cardParceiro";
import fenaconImg from "../../../../assets/fenacon.png";
import valleImg from "../../../../assets/valle.png";
import confereLeaoImg from "../../../../assets/confere-leao.png";
import contmidiaImg from "../../../../assets/contmidia.png";
import { felixTokens } from "../../../../theme";

/* Os logos dos parceiros são desenhados para fundo escuro (arte branca/amarela).
   Por isso a placa do card não acompanha o tema: usa o par escuro do sistema
   (`dark.surface` + `paperInk`) nos dois modos. Nenhuma cor solta — só token. */
const PLACA_PARCEIRO = felixTokens.dark.surface;
const TINTA_PARCEIRO = felixTokens.paperInk;

export const Fenacon: ParceiroType = {
  cor: TINTA_PARCEIRO,
  imagem: fenaconImg,
  subcor: "text.secondaryWhite",
  background: PLACA_PARCEIRO,
  nome: "Clube+ Fenacon",
  descricao:
    "Cliente Clube+ Fenacon, aproveite descontos exclusivos nos planos da Felix na Bolsa para automatizar os cálculos do IR dos seus clientes com Renda Variável.",
};

export const Valle: ParceiroType = {
  cor: TINTA_PARCEIRO,
  imagem: valleImg,
  subcor: "text.secondary",
  background: PLACA_PARCEIRO,
  nome: "Valle",
  descricao:
    "A Valle Consultores é parceira da Felix na Bolsa e utiliza a ferramenta para automatizar os cálculos do serviço de controle fiscal mensal que oferece para seus clientes que investem na Bolsa.",
};

export const ConfereLeao: ParceiroType = {
  cor: TINTA_PARCEIRO,
  imagem: confereLeaoImg,
  subcor: "text.secondaryWhite",
  background: PLACA_PARCEIRO,
  nome: "Confere Leão",
  descricao:
    "O Confere Leão é uma ferramenta para auxiliar contadores na gestão e acompanhamento do Imposto de Renda Pessoa Física que automatiza processos, aumenta a produtividade e garante maior precisão nas declarações.",
};

export const ContMidia: ParceiroType = {
  cor: TINTA_PARCEIRO,
  imagem: contmidiaImg,
  subcor: "text.secondaryWhite",
  background: PLACA_PARCEIRO,
  nome: "ContMídia",
  descricao:
    "A ContMídia é a melhor solução de marketing e vendas especializada em escritórios contábeis que faturam acima de 50 mil e querem escalar com previsibilidade, autoridade e lucro.",
};

class ParceiroType {
  public cor!: string;
  public imagem!: string;
  public subcor!: string;
  public nome!: string;
  public descricao!: string;
  public background!: string;
}

export default function AbaParceiros() {
  return (
    <Container maxWidth="md" disableGutters>
      <Box py={3}>
        <Typography variant="eyebrow" color="text.secondary" component="p">
          Benefícios
        </Typography>
        <Typography variant="h2" color="text.primary" gutterBottom mt={0.5}>
          Parceiros Felix na Bolsa
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Conheça nossos parceiros que oferecem benefícios exclusivos para
          contadores usuários da Felix na Bolsa.
        </Typography>

        <Grid container spacing={3} mt={1}>
          <Grid item xs={12} md={6}>
            <CardParceiro
              nome={ConfereLeao.nome}
              descricao={ConfereLeao.descricao}
              logo={
                <img
                  src={confereLeaoImg}
                  alt="Confere Leão"
                  height={40}
                  style={{ objectFit: "contain" }}
                />
              }
              ctaLabel="Conhecer o Confere Leão"
              ctaHref="https://marketing.confereleao.com.br/confere-leao-felix-na-bolsa"
              background={ConfereLeao.background}
              textColor={ConfereLeao.cor}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <CardParceiro
              nome={ContMidia.nome}
              descricao={ContMidia.descricao}
              logo={
                <img
                  src={contmidiaImg}
                  alt="ContMídia"
                  height={40}
                  style={{ objectFit: "contain" }}
                />
              }
              ctaLabel="Diagnóstico de Marketing Grátis"
              ctaHref="https://contmidia.com/"
              background={ContMidia.background}
              textColor={ContMidia.cor}
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
